
<div class="p-grid">
    <div class="p-col-2 panelClass">
        <p-panelMenu [tabindex]="tabindex" [model]="configMenuDocument" [style]="{'width':'100%'}"></p-panelMenu>
    </div>
    <div class="p-col-10">
        <div class="card reportBody p-p-0">
            <div class="p-col-12 p-p-0">
                <p-menu #configmenuFilesUpload [model]="menuItemsFiles" [popup]="true" class="sideBar">
                </p-menu>
                <div class="tabviewIcons">
                    <span class="btnBars p-mr-0" (click)="refreshListing()" pTooltip="Refresh" tooltipPosition="top">
                        <i class="pi pi-refresh"></i>
                    </span>
                    <div *ngIf="selectedDocumentWindow !== 'download'" class="btnBars p-mr-0" style="margin-top: 1px;" (click)="configmenuFilesUpload.toggle($event)">
                        <i class="pi pi-bars"></i>
                    </div>
                </div>
                <div *ngIf="selectedDocumentWindow === 'files'">
                    <p-breadcrumb [model]="itemsHeader" [home]="homeHeader" (onItemClick)="openFolderFromBreadcumb($event)">
                    </p-breadcrumb>
                    <p-table [value]="allFilesFolder" [loading]="isLoading">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon></th>
                                <th pSortableColumn="createdDate">Created <p-sortIcon field="createdDate"></p-sortIcon></th>
                                <th pSortableColumn="updatedDate">Modified <p-sortIcon field="updatedDate"></p-sortIcon></th>
                                <th pSortableColumn="createdBy">Created By <p-sortIcon field="createdBy"></p-sortIcon></th>
                                <!-- <th>Sharing</th> -->
                                <th pSortableColumn="downloadCount">Total Download <p-sortIcon field="downloadCount"></p-sortIcon></th>
                                <th pSortableColumn="versionCount">Version Count <p-sortIcon field="versionCount"></p-sortIcon></th>
                                <th>Action</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-file>
                            <tr>
                                <td *ngIf="file.isFolder" class="pointer" (click)="openFolder(file)" [pTooltip]="file.name">
                                    <span>
                                        <i class="pi pi-folder-open"></i>
                                    </span> {{ file.name | shorten }}
                                </td>
                                <td *ngIf="!file.isFolder" class="open-file" (click)="openFilePreview(file)" [pTooltip]="file.name + '.' + file.extension" fitContent="false">
                                    {{ file.name | shorten }}<span *ngIf="file.extension">.{{file.extension}}</span>
                                </td>
                                <td>{{file.createdDate | localDate}}</td>
                                <td>{{file.updatedDate | localDate}}</td>
                                <td>{{file.createdBy}}</td>
                                <!-- <td>{{file.mediaType}}</td> -->
                                <td>{{file.downloadCount}}</td>
                                <td>
                                    <a *ngIf="!file.isFolder" style="cursor: pointer;" pTooltip="Click to show versions" tooltipPosition="top" (click)="openDocumentVersions(file)">
                                        {{file.versionCount ?? 0}}
                                    </a>
                                </td>
                                <td class="action">
                                    <span class="btnBars p-mr-0" pTooltip="Share" tooltipPosition="top" (click)="openShare(file)"><i
                                            class="pi pi-user-plus"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Download" *ngIf="!file.isFolder" (click)="downloadSingleFile(file)" tooltipPosition="top"><i
                                            class="pi pi-download"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Download" *ngIf="file.isFolder" (click)="downloadSingleFile(file)" tooltipPosition="top"><i
                                            class="pi pi-download"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Edit" (click)="editUpload(file)" tooltipPosition="top"><i
                                            class="pi pi-pencil"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Delete" *ngIf="file.mediaType != 'Folder'" tooltipPosition="top" (click)="DeleteFile(file.id, file.name, file.parentFolderId)"><i
                                            class="pi pi-trash"></i>
                                    </span>
                                    <span class="btnBars p-mr-0" pTooltip="Delete" *ngIf="file.mediaType == 'Folder'" tooltipPosition="top" (click)="DeleteFolder(file.id, file.name, file.parentFolderId)"><i
                                            class="pi pi-trash"></i>
                                    </span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage">
                            <tr>
                                <td colspan="6">
                                    {{ filesFolderDataText }}
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>

                </div>
                <div *ngIf="selectedDocumentWindow === 'recent'">
                    <p-breadcrumb [model]="itemsHeader" [home]="homeRecentHeader"></p-breadcrumb>
                    <p-table [value]="sharedFilesAndFolders">
                        <ng-template pTemplate="header">
                            <tr>
                                <th>Name</th>
                                <th>Created</th>
                                <th>Created By</th>
                                <th>Sharing</th>
                                <!-- <th>Total Views</th> -->
                                <th>Action</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <td class="pointer" (click)="openFile(product)">
                                    <span *ngIf="product.group == 'folder'">
                                        <i class="pi pi-folder-open"></i>
                                    </span> {{product.name}}
                                </td>
                                <td>{{product.updatedDate | localDate}}</td>
                                <td>{{product.updatedBy}}</td>
                                <td>{{product.type}}</td>
                                <td>{{product.views}}</td>
                                <td class="action">
                                    <span class="btnBars p-mr-0" pTooltip="Share" tooltipPosition="top"><i
                                            class="pi pi-user-plus"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Download" tooltipPosition="top"><i
                                            class="pi pi-download"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"><i
                                            class="pi pi-pencil"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top"><i
                                            class="pi pi-trash"></i></span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage" *ngIf="recentData.length == 0">
                            <tr>
                                <td colspan="6">
                                    No records found.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <div *ngIf="selectedDocumentWindow === 'shared'">
                    <p-breadcrumb [model]="itemsHeader" [home]="homeSharedHeader" (onItemClick)="openSharedFolderFromBreadcumb($event)"></p-breadcrumb>
                    <p-table [value]="sharedFilesAndFolders" [loading]="isLoading">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon></th>
                                <th pSortableColumn="attachmentCreatedDate">Created <p-sortIcon field="attachmentCreatedDate"></p-sortIcon></th>
                                <th pSortableColumn="attachmentCreatedBy">Created By <p-sortIcon field="attachmentCreatedBy"></p-sortIcon></th>
                                <!-- <th>Sharing</th> -->
                                <!-- <th>Total Views</th> -->
                                <th>Action</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <!-- <td class="pointer" (click)="openFile(product)">
                                    <span *ngIf="product.isFolder">
                                        <i class="pi pi-folder-open"></i>
                                    </span> {{product.name}}
                                </td> -->
                                <td *ngIf="product.isFolder" class="pointer" (click)="openSharedFolder(product)" [pTooltip]="product.name">
                                    <span>
                                        <i class="pi pi-folder-open"></i>
                                    </span> {{ product.name | shorten }}
                                </td>
                                <td *ngIf="!product.isFolder" class="open-file" (click)="openFilePreview(product)" [pTooltip]="product.name + '.' + product.extension" fitContent="false">
                                    {{ product.name | shorten }}<span *ngIf="product.extension">.{{product.extension}}</span>
                                </td>
                                <td>{{product.attachmentCreatedDate | localDate}}</td>
                                <td>{{product.attachmentCreatedBy}}</td>
                                <!-- <td>{{product.type}}</td> -->
                                <!-- <td>{{product.views}}</td> -->
                                <td class="action">
                                    <!-- <span class="btnBars p-mr-0" pTooltip="Share" tooltipPosition="top"><i
                                                                            class="pi pi-user-plus"></i></span> -->
                                    <!-- <span *ngIf="product?.downloadable" class="btnBars p-mr-0" pTooltip="Download" tooltipPosition="top"><i
                                                                            class="pi pi-download"></i></span> -->
                                    <span [ngClass]="product.downloadable ? 'enable' : 'disable'" class="btnBars p-mr-0" pTooltip="Download"
                                        *ngIf="!product.isFolder" (click)="downloadSingleFile(product)" tooltipPosition="top"><i
                                            class="pi pi-download"></i></span>
                                    <span [ngClass]="product.downloadable ? 'enable' : 'disable'" class="btnBars p-mr-0" pTooltip="Download"
                                        *ngIf="product.isFolder" (click)="downloadSingleFile(product)" tooltipPosition="top"><i
                                            class="pi pi-download"></i></span>
                                    <span [ngClass]="product.writable ? 'enable' : 'disable'" (click)="editUpload(product)" class="btnBars p-mr-0"
                                        pTooltip="Edit" tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Delete" *ngIf="product?.mediaType != 'Folder'" tooltipPosition="top"
                                        (click)="deleteSharedFile(product.id, product.name, product.parentFolderId)"><i class="pi pi-trash"></i>
                                    </span>
                                    <span class="btnBars p-mr-0" pTooltip="Delete" *ngIf="product?.mediaType == 'Folder'" tooltipPosition="top"
                                        (click)="deleteSharedFolder(product.id, product.name, product.parentFolderId)"><i class="pi pi-trash"></i>
                                    </span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage" *ngIf="sharedFilesAndFolders?.length == 0">
                            <tr>
                                <td colspan="6">
                                    No records found.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <div *ngIf="selectedDocumentWindow === 'download'">
                    <p-breadcrumb [model]="itemsHeader" [home]="homeDownloadHeader" (onItemClick)="openFolderFromBreadcumb($event)">
                    </p-breadcrumb>
                    <p-table [value]="allFilesFolder" [loading]="isLoading">
                        <ng-template pTemplate="header">
                            <tr>
                                <th pSortableColumn="name">Name <p-sortIcon field="name"></p-sortIcon></th>
                                <th pSortableColumn="createdDate">Created <p-sortIcon field="createdDate"></p-sortIcon></th>
                                <th pSortableColumn="updatedDate">Modified <p-sortIcon field="updatedDate"></p-sortIcon></th>
                                <th pSortableColumn="createdBy">Created By <p-sortIcon field="createdBy"></p-sortIcon></th>
                                <!-- <th>Sharing</th> -->
                                <th pSortableColumn="downloadCount">Total Download <p-sortIcon field="downloadCount"></p-sortIcon></th>
                                <th>Action</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-product>
                            <tr>
                                <!-- <td class="pointer" (click)="openFile(product)">
                                    <span *ngIf="product.group == 'folder'">
                                        <i class="pi pi-folder-open"></i>
                                    </span>
                                    {{product.name}}
                                </td> -->
                                <td *ngIf="product.isFolder" class="pointer" (click)="openFolder(product)" [pTooltip]="product.name">
                                    <span>
                                        <i class="pi pi-folder-open"></i>
                                    </span> {{ product.name | shorten }}
                                </td>
                                <td *ngIf="!product.isFolder" class="open-file" (click)="openFilePreview(product)" [pTooltip]="product.name + '.' + product.extension">
                                    {{ product.name | shorten }}<span *ngIf="product.extension">.{{product.extension}}</span>
                                </td>
                                <td>{{product.createdDate | localDate}}</td>
                                <td>{{product.updatedDate | localDate}}</td>
                                <td>{{product.createdBy}}</td>
                                <!-- <td>{{product.mediaType}}</td> -->
                                <td>{{product.downloadCount}}</td>
                                <!-- <td class="action">
                                    <span class="btnBars p-mr-0" pTooltip="Share" tooltipPosition="top"><i
                                            class="pi pi-user-plus"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Download" tooltipPosition="top"><i
                                            class="pi pi-download"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"><i
                                            class="pi pi-pencil"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Delete" tooltipPosition="top"><i
                                            class="pi pi-trash"></i></span>
                                </td> -->
                                <td class="action">
                                    <!-- <span class="btnBars p-mr-0" pTooltip="Share" tooltipPosition="top"><i
                                            class="pi pi-user-plus"></i></span> -->
                                    <span class="btnBars p-mr-0" pTooltip="Download" *ngIf="product.mediaType != 'Folder'" (click)="downloadSingleFile(product)" tooltipPosition="top"><i class="pi pi-download"></i></span>
                                    <span class="btnBars p-mr-0" pTooltip="Download" *ngIf="product.mediaType == 'Folder'" (click)="downloadAsZip(product)" tooltipPosition="top"><i class="pi pi-download"></i></span>
                                    <!-- <span class="btnBars p-mr-0" pTooltip="Edit" tooltipPosition="top"><i
                                            class="pi pi-pencil"></i></span> -->
                                    <span class="btnBars p-mr-0" pTooltip="Delete" *ngIf="product.mediaType != 'Folder'" tooltipPosition="top" (click)="DeleteFile(product.id, product.name, product.parentFolderId)"><i
                                            class="pi pi-trash"></i>
                                    </span>
                                    <span class="btnBars p-mr-0" pTooltip="Delete" *ngIf="product.mediaType == 'Folder'" tooltipPosition="top" (click)="DeleteFolder(product.id, product.name, product.parentFolderId)"><i
                                            class="pi pi-trash"></i>
                                    </span>
                                </td>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="emptymessage" *ngIf="downloadsFilesAndFolder.length == 0">
                            <tr>
                                <td colspan="6">
                                    No records found.
                                </td>
                            </tr>
                        </ng-template>
                    </p-table>
                </div>
                <p-paginator *ngIf="totalRecords>0" [rows]="pageSize" [totalRecords]="totalRecords" [first]="first" [showCurrentPageReport]="true" [rowsPerPageOptions]="tableShowMore" currentPageReportTemplate="Showing {first} to {last} of {totalRecords}
                        entries" (onPageChange)="getFilesWithPagination($event)">
                </p-paginator>
            </div>
        </div>
    </div>
</div>

<p-dialog [header]="modalHeader" [(visible)]="displayNewFile" [modal]="true" [closable]="false" [style]="{width: '50vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label *ngIf="!isUpload">
                    Folder Name
                    <span style="color: red;"> * </span>
                </label>
                <input *ngIf="!isUpload" type="text" pInputText [(ngModel)]="newFileFolder.name">
                <!-- <input *ngIf="isUpload" type="text" pInputText [(ngModel)]="uploadFilePath" class="readOnly"> -->
                <label *ngIf="isUpload">
                    Folder Path
                </label>
                <input *ngIf="isUpload" type="text" pInputText [(ngModel)]="uploadFilePath" class="readOnly" disabled>
                <!-- <span *ngIf="isUpload" type="text"  class="readOnly">{{uploadFilePath}}</span> -->
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label>
                    Upload
                    <i class="pi pi-info-circle p-ml-1 info-icon" [pTooltip]="tooltipText" showDelay="100"
                        tooltipStyleClass="info-tooltip"></i>
                </label>
                <p-messages [(value)]="maxFilesizeErrorMessage" [enableService]="false" [closable]="false"></p-messages>
                <p-messages [(value)]="maxNoOfFilesErrorMessage" [enableService]="false" [closable]="false"></p-messages>
                <p-fileUpload multiple="multiple" maxFileSize="25000000" [files]="files" [showUploadButton]="false" (onSelect)="uploadAttachments($event.files)" (onClear)="removeAllFiles()" name="myfile[]"  #fileUploader>
                    <ng-template pTemplate="file">
                    </ng-template>
                    <ng-template pTemplate="content" >
                        <ng-container *ngIf="newFileFolder?.fileOtherInfoJsonList?.length > 0">
                            <div class="file-info" *ngFor="let item of newFileFolder.fileOtherInfoJsonList">
                                <p-checkbox [binary]="true" [(ngModel)]="item.isFileReplacable" [pTooltip]="'Replace if file already exists.'" tooltipPosition="top">
                                </p-checkbox>
                                <img  class="file-icon" [src]="getFileIcon(item.name + '.' + item.extension)" alt="Invalid File">
                                <div [pTooltip]="item.name" class="truncate">
                                    {{ item.name }}
                                </div>
                                <div>
                                    <small class="p-invalid" *ngIf="!item.isFileReplacable && item.fileExist">File already exist!</small>
                                </div>
                                <div>
                                    {{ item.size | fileSize }}
                                </div>
                                <p-button icon="pi pi-times" iconPos="left" class="p-button-danger" (click)="removeFromUpload(item, item, fileUploader)"></p-button>
                            </div>
                        </ng-container>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="setFileDefault()" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" pButton label="Save" (click)="createUpdateFolderFilesWaringg()" [disabled]="(!newFileFolder.name ||
            newFileFolder.childFiles.length > 3) || (isUpload && !newFileFolder.childFiles.length) ||  totalFileSize > 25000000">
        </button>
    </p-footer>
</p-dialog>




<app-shared-file-opener *ngIf="displayFilePreview" [modalDisplay]="displayFilePreview" [modalFile]="currentFile" (closeFilePreview)="closeFilePreview()">
</app-shared-file-opener>

<p-confirmDialog key="folderDelete"></p-confirmDialog>
<p-confirmDialog key="fileDelete"></p-confirmDialog>
<p-toast position="top-right" [baseZIndex]="10000"></p-toast>



<p-dialog header="Assign Permission & Share" [(visible)]="displayShareAssign" [modal]="true" [closable]="false"
    [style]="{width: '50vw'}">
    <div class="header">
        <h5>
            <span *ngIf="tempShare?.mediaType == 'Folder'">Folder:</span>
            <span *ngIf="tempShare?.mediaType == 'File'">File:</span>
            {{tempShare?.name}}
        </h5>
        <div>
            <input pInputText type="text" [(ngModel)]="documentUserSearchText"
                (ngModelChange)="userQuestionUpdate.next($event)"
                (input)="dt1.filterGlobal($event.target.value, 'contains')" placeholder="Search keyword" />
        </div>
    </div>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <p-table [value]="permissionList" responsiveLayout="scroll" [paginator]="true" [rows]="pageSize"
                    [showCurrentPageReport]="true" responsiveLayout="scroll" [lazy]="true" [totalRecords]="totalRecordsShare"
                    (onLazyLoad)="onPageChange($event)"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    [rowsPerPageOptions]="tableShowMore" paginatorDropdownAppendTo="body" #dt1
                    [globalFilterFields]="['userName']">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>User Name</th>
                            <th class="action">
                                <p-checkbox [(ngModel)]="allReadCheck" [binary]="true" inputId="binary"
                                    (onChange)="checkAll('Read',$event)"></p-checkbox>
                                Read
                            </th>
                            <th class="action">
                                <p-checkbox [(ngModel)]="allWriteCheck" [binary]="true" inputId="binary"
                                    (onChange)="checkAll('Write',$event)"></p-checkbox>
                                Write
                            </th>
                            <th class="action">
                                <p-checkbox [(ngModel)]="allDownLoadCheck" [binary]="true" inputId="binary"
                                    (onChange)="checkAll('Download',$event)"></p-checkbox>
                                Download
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                        <tr>
                            <td>{{product.userName}}</td>
                            <td class="action">
                                <p-checkbox [(ngModel)]="product.readable" [binary]="true" inputId="binary"
                                    (onChange)="isCheckAll(product)"></p-checkbox>
                            </td>
                            <td class="action">
                                <p-checkbox [(ngModel)]="product.writable" [binary]="true" inputId="binary"
                                    (onChange)="isCheckAll(product)"></p-checkbox>
                            </td>
                            <td class="action">
                                <p-checkbox [(ngModel)]="product.downloadable" [binary]="true" inputId="binary"
                                    (onChange)="isCheckAll(product)"></p-checkbox>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
    <p-footer>
        <button type="button" pButton (click)="cancel()" label="Cancel" class="p-button-secondary"></button>
        <button type="submit" (click)="assignRights()" pButton label="Ok">
        </button>
    </p-footer>
</p-dialog>


<p-dialog header="Edit Document" [(visible)]="displayNewUpload" [modal]="true" [closable]="false"
    [style]="{width: '60vw'}">
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12">
                <label>Document Name</label>
                <input  type="text" pInputText [(ngModel)]="tempDuc.name">
                <!-- <input *ngIf="saveBtn == 'upload'" type="text" pInputText > -->
            </div>
        </div>
        <!-- <div class="p-grid">
            <div class="p-col-12">
                <label>Upload</label>
                <p-fileUpload multiple="multiple" maxFileSize="10485760" [files]="files" [showUploadButton]="false" (onSelect)="uploadAttachments($event.files)" (onClear)="removeAllFiles()" name="myfile[]" fileLimit="3" #fileUploader>
                    <ng-template pTemplate="file" let-file>
                        <div class="file-info">
                            <div>
                                <img class="file-icon" [src]="getFileIcon(file.name)" alt="Invalid File">
                            </div>
                            <div [pTooltip]="file.name" class="truncate">
                                {{ file.name }}
                            </div>
                            <div>
                                {{ file.size | fileSize }}
                            </div>
                            <div>
                                <p-button icon="pi pi-times" iconPos="left" class="p-button-danger" (click)="removeFromUpload(file, fileUploader)"></p-button>
                            </div>
                        </div>
                    </ng-template>
                </p-fileUpload>
            </div>
        </div> -->
    </div>
    <p-footer>
        <button type="button" pButton (click)="displayNewUpload=false" label="Cancel"
            class="p-button-secondary"></button>
        <button  type="submit" pButton label="Save" (click)="editDocument(selectedDocumentWindow)"></button>
        <!-- <button *ngIf="saveBtn == 'upload'" type="submit" pButton label="Save" (click)="save()"></button> -->
    </p-footer>
</p-dialog>



<p-dialog header="Document Versions" [(visible)]="showDocumentVersionsDialog" [modal]="true" [closable]="true"
    [style]="{width: '60vw'}">
    <p-table [value]="documentVersionsLists" [loading]="isLoading">
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Created</th>
                <th>Version Number</th>
                <th>Action</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-file>
            <tr>
                <td class="open-file" (click)="openFilePreviewVersion(file)" [pTooltip]="file.attachmentName + '.' + file.extension" fitContent="false" tooltipPosition="top">
                    {{ file.attachmentName | shorten }}<span *ngIf="file.extension">.{{file.extension}}</span>
                </td>
                <td>{{file.versionId | localDate}}</td>
                <td>
                    {{file.versionNumber}}
                </td>
                <td class="action">
                    <span class="btnBars p-mr-0" pTooltip="Download" *ngIf="!file.isFolder" (click)="downloadSingleFileVersion(file)" tooltipPosition="top"><i
                            class="pi pi-download"></i></span>
                    <span class="btnBars p-mr-0" pTooltip="Download" *ngIf="file.isFolder" (click)="downloadSingleFileVersion(file)" tooltipPosition="top"><i
                            class="pi pi-download"></i></span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="6">
                    {{ filesFolderDataText }}
                </td>
            </tr>
        </ng-template>
    </p-table>
</p-dialog>
